module.exports = __webpack_public_path__ + "static/images/shopify-x-grabexpress.3nou5zc.png";